import { css } from '@emotion/core';
import { tokens, media, buttonNormalize } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  borderRadius = tokens.borderRadius;
var bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini,
  miniBold = designTokenFonts.miniBold;
export var text = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", media('<tablet'), "{", mini, ";}");
export var autocomplete = /*#__PURE__*/css("width:449px;", media('<tablet'), "{width:100%;}");
export var address = /*#__PURE__*/css(bodyBold, ";", media('<tablet'), "{", miniBold, ";}");
export var changeAddressLink = /*#__PURE__*/css(buttonNormalize, ";color:", colors.interactive.base.default, ";text-decoration:none;cursor:pointer;&:hover{color:", colors.interactive.base.hover, ";}", media('<tablet'), "{", mini, ";}");
export var selectedAddressBox = /*#__PURE__*/css("border:1px solid ", colors.neutral.trim.default, ";border-radius:", borderRadius.inner, ";");